// 将时间戳处理成2021年12月9日12:10
const timeFormat1 = (str) => {
  const oDate = new Date(str * 1000)
  const oYear = oDate.getFullYear()
  const oMonth = oDate.getMonth() + 1
  const oDay = oDate.getDate()
  const oHour =
    oDate.getHours() > 9 ? oDate.getHours() : '0' + oDate.getHours()
  const oMinute =
    oDate.getMinutes() > 9 ? oDate.getMinutes() : '0' + oDate.getMinutes()
  const oTime =
    oYear + '年' + oMonth + '月' + oDay + '日' + oHour + ':' + oMinute
  // 最后拼接时间
  if (oYear && oMonth && oDay) {
    return oTime
  }
};
//将时间戳处理成2021.12.09
const timeFormat2 = (str) => {
  const oDate = new Date(str * 1000)
  const oYear = oDate.getFullYear()
  const oMonth = oDate.getMonth() + 1
  const oDay = oDate.getDate()
  const oTime = oYear + '.' + oMonth + '.' + oDay + '' // 最后拼接时间
  if (oYear && oMonth && oDay) {
    return oTime
  }
}
// 将时间戳处理成2021.12.09 13：09
const timeFormat3 = (str) => {
  const oDate = new Date(str * 1000)
  const oYear = oDate.getFullYear()
  const oMonth = oDate.getMonth() + 1
  const oDay = oDate.getDate()
  const oHour =
    oDate.getHours() > 9 ? oDate.getHours() : '0' + oDate.getHours()
  const oMinute =
    oDate.getMinutes() > 9 ? oDate.getMinutes() : '0' + oDate.getMinutes()
  const oTime =
    oYear + '.' + oMonth + '.' + oDay + ' ' + oHour + ':' + oMinute
  // 最后拼接时间
  if (oYear && oMonth && oDay) {
    return oTime
  }
}
// 将时间戳处理成2021年12月9日
const timeFormat4 = (str) => {
  const oDate = new Date(str * 1000)
  const oYear = oDate.getFullYear()
  const oMonth = oDate.getMonth() + 1
  const oDay = oDate.getDate()
  const oTime =
    oYear + '年' + oMonth + '月' + oDay + '日'
  // 最后拼接时间
  if (oYear && oMonth && oDay) {
    return oTime
  }
};
module.exports ={
  timeFormat1,
  timeFormat2,
  timeFormat3,
  timeFormat4
}